<template >
    <div id="manageAsPro">
        <div class="mybreadcrumb">
            <div style="display:flex;align-items:center">
                <i class="iconfont icon-shouquan-tianchong" style="margin-right:10px;color:#999"></i>
                <el-breadcrumb separator-class="el-icon-arrow-right" >
                    <el-breadcrumb-item>授权管理</el-breadcrumb-item>
                    <el-breadcrumb-item>按产品</el-breadcrumb-item>
                    <el-breadcrumb-item>{{productName}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <button class="return-button" @click="returnClick">返回</button>
        </div>
        <div class="package-info">
            <p class="packagename">{{productName}}</p>
            <div class="restpower">
                <span>可用授权 :</span>
                <span class="reststyle">{{unUsedSNCount}}</span>
                <span>({{allSNCount}})</span>
            </div>
        </div>
        <div v-loading="memberloading" element-loading-text="数据加载中...">
        <div class="operate-box">
            <span>已分配授权信息</span>
            <div class="operate-right">
                <el-input placeholder="手机号/姓名/部门" size="medium" style="margin-right:15px" v-model="grantOrCancelinputseatch" @keyup.enter.native="getSearchGrantList">
                    <i slot="suffix" class="el-input__icon el-icon-search" style="cursor:pointer" @click="getSearchGrantList"></i>
                </el-input>
                <el-button type="primary" class="operate-btn" @click="proBtnClick">分配授权</el-button>
                <el-button  class="operate-btn" @click="confirmMessage('cancle')" :disabled="cancleBtnDisable">取消分配</el-button>
            </div> 
        </div>
        <div style="padding:15px 30px 30px 30px" >
            <el-table
            
            :data="tableData"
            border
            :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
            style="width: 100%"
            :cell-class-name="tabCellClassName"
             @selection-change="handleSelectionChange">
            <el-table-column
            type="selection"
            width="55"
            align="center">
            </el-table-column>
            <el-table-column
                    label="序号"
                    type="index"
                    width="60"
                    align="center"
                    >
                <template slot-scope="scope">
                    <span>{{(pageIndex-1) * pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            show-overflow-tooltip>
            </el-table-column>
            <el-table-column
            prop="realName"
            label="姓名/企业昵称"
            show-overflow-tooltip
            align="center">
            </el-table-column>
            <el-table-column
            prop="department"
            label="部门"
            show-overflow-tooltip
            align="center">
            </el-table-column>
            <el-table-column
                label="在线状态"
                width="160"
                align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.isOnLine" class="table-status bgcgreen">
                        <span >在线</span>
                    </div> 
                    <div  v-else class="table-status bgcorange">
                        <span>离线</span>
                    </div>
                   
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="操作"
                width="140">
                        <template slot-scope="scope">
                            <div @click="TTperson(scope.row)" :class="scope.row.isOnLine?'manage-button':'dismanage-button'">强制下线</div>
                        </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,30]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-size="pageSize"
                style="margin-top:30px">
        </el-pagination>
        </div>
        </div>
        <el-dialog
            title="分配授权"
            :visible.sync="proPowerDialog"
            width="700px"
            :close-on-click-modal="false">
            <div class="search-wraper">
                <el-input v-model.trim="serchinput" 
                size="small" placeholder="手机号/姓名/部门" 
                maxlength="30"
                @keyup.enter.native="searchClick"></el-input>
                <i class="el-icon-search search" @click="searchClick"></i>
                <span style="font-size:12px;margin-left:10px">企业成员只能使用本部门及以上部门的授权。</span>
            </div>
            <el-table
                :data="DiaTableData"
                border
                :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
                style="width: 100%;"
                :cell-class-name="tabCellClassName"
                @selection-change="grantSelectionChange">
                <el-table-column
                type="selection"
                width="55"
                align="center">
                </el-table-column>
                <el-table-column
                        label="序号"
                        type="index"
                        width="60"
                        align="center"
                        >
                    <template slot-scope="scope">
                        <span>{{scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="phone"
                label="手机号"
                align="center"
                show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                prop="realName"
                label="姓名/企业昵称"
                width="100"
                align="center">
                </el-table-column>
                <el-table-column
                prop="department"
                label="部门(可用授权数量)"
                show-overflow-tooltip
                align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.department}}（{{scope.row.useSNCount}}）</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="addedAt"
                label="加入时间"
                show-overflow-tooltip
                align="center"
                sortable>
                </el-table-column>

            </el-table>

            <div slot="footer">
                <el-button @click="proPowerDialog = false">取 消</el-button>
                <el-button type="primary" @click="confirmMessage('grant')" :disabled="empoerBtnDisable">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog
            title="设备列表"
            :visible.sync="devicedialogVisible"
            width="600px"
            >
            <div>
                <el-table
                    :data="devicedata"
                    style="width: 100%"
                    border
                    height="100%"
                    :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
                    :cell-class-name="tabCellClassName"
                    header-align="center">
                    <el-table-column type="index" label="序号" width="60" align="center" />
                    <el-table-column
                        align="center"
                        label="激活时间"
                        prop="regDate"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.regDate | dateFilter}}</span>
                            
                         </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="指纹"
                        prop="mid"
                        show-overflow-tooltip >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="状态"
                        prop="status"
                        show-overflow-tooltip>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" style="text-align:center">
                <el-button @click="devicedialogVisible = false" style="text-align:center">关闭</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="提示"
            :visible.sync="TTpersonDialog"
            width="400px"
            class="ttdialog"
            :close-on-click-modal="false">
                <div style="display:flex;margin-top:20px;align-items:center"> 
                    <img :src="wenhaopng" alt="" style="width:50px;height:50px;margin-left:30px;">
                    <div class="tttipsstyle">
                        被强制下线后该用户本次将不能继续使用软件授权，如需使用再次登录即可。确定要将该用户强制下线吗？
                    </div>
                </div>

            <div slot="footer" style="display:flex;justify-content:center">
                <el-button @click="TTpersonDialog = false" style="margin-right:10px">取 消</el-button>
                <el-button type="primary" @click="ttConfirmClick">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="提示"
            :visible.sync="xiaxiantipsDialog"
            width="400px"
            class="ttdialog"
            :close-on-click-modal="false">
                <div style="display:flex;margin-top:20px;padding-bottom:30px;align-items:center"> 
                    <img :src="tanhao" alt="" style="width:50px;height:50px;margin-left:30px;">
                    <div class="tttipsstyle">
                        {{tipsphone}}已被强制下线！
                    </div>
                </div>
        </el-dialog>

    </div>
</template>

<script>
import moment from 'moment'
import wenhaopng from '@/assets/img/companyuserpng/wenhao.png'
import tanhao from '@/assets/img/companyuserpng/tanhao.png'
import duigoufill from '@/assets/img/companyuserpng/duigoufill.png'
import {mydebounce} from '@/js/common.js'
import {
        GetPagedSNGrantedUsersApi,
        CancelUsersProductSNApi,
        GetSNUnGrantedEnterpriseUsersApi,
        GetProductGrantInfoApi, 
        GrantProductToMultiUserApi,
        BatchGrantSAASToEnterpriseUserApi,
        CancelUsersSAASApi,
        SetClientUserForceOffLineApi,
        GetProductSnInDepartmentApi
        } from '@/js/enterPriseApi'
import {MyZhugeTrackGoManagePage,MyZhugeTrackGrantSN,MyZhugeTrackCancleGrantSN} from '@/js/zhugemaidian.js' 
export default {
    name:'MemberManage',
    data(){
        return{
            empoerBtnDisable:false,
            tanhao,
            memberloading:false,
            xiaxiantipsDialog:false,
            TTpersonDialog:false,
            devicedata:[],
            devicedialogVisible:false,
            companypic:require('../../../assets/img/wxzfbpay/phone.png'),
            wenhaopng,//问号图片
            duigoufill,//对勾图片
            tips:'success',
            productName:'',
            proPowerDialog:false,
            serchinput:'',
            pageSize:10,
            pageIndex:1,
            total:0,
            hasPreviousPage:false,
            unUsedSNCount:'',
            allSNCount:'',
            tableData: [],
            multipleSelection: [],
            grantMultiselection:[],
            DiaTableData:[],
            mainId:'',
            detailName:'',
            currentttrow:{},
            tipsphone:'',
            productType:'',//1SAAS产品，0客户端软件
            grantOrCancelinputseatch:''
        }
    },
    created(){
        let query=this.$route.query;
        const detailName=query.productName;
        const mainId=query.mainId;
        this.productType=query.productType;
        if(detailName && mainId){
            this.mainId=mainId;
            this.detailName=detailName;
            this.getProductInfo(mainId);
            this.GetSNGrantedUsers({
                mainId:this.mainId,
                pageIndex:this.pageIndex,
                pageSize:this.pageSize
            });
        }
    },
    mounted(){
        MyZhugeTrackGoManagePage({
            "管理方式":'按产品'
        })
    },
    filters:{
        dateFilter(val){
            return moment(val).format("YYYY-MM-DD HH:mm:ss");
        }
    },
    computed:{
        cancleBtnDisable(){
            if(this.multipleSelection.length>0){
                return false;
            }else{
                return true;
            }
        }
    },
    methods:{
        handleSizeChange(val){//每页多少改变触发
            let that=this;
            this.pageSize=val;
            this.GetSNGrantedUsers({
                mainId:this.mainId,
                pageIndex:1,
                pageSize:val
            })
        },
        getSearchGrantList(){
            this.GetSNGrantedUsers({
                mainId:this.mainId,
                pageIndex:1,
                pageSize:this.pageSize
            })
        },
        handleCurrentChange(currentpage){//当前页数切换
            let that=this;
            this.GetSNGrantedUsers({
                mainId:this.mainId,
                pageIndex:currentpage,
                pageSize:that.pageSize
            })
            setTimeout(()=>{
                that.pageIndex=currentpage;
            },0)
        },
        TTperson(row){//强制下线文字点击
            console.log(row)
            if(!row.isOnLine){
                return 
            }

            this.currentttrow=null,
            this.currentttrow=row;
            this.TTpersonDialog=true
        },
        ttConfirmClick(){//dialog弹窗确认按钮点击
            let that=this;
            SetClientUserForceOffLineApi({
                userPhone:this.currentttrow.phone,
                sn:this.currentttrow.sn
            })
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data){
                        this.TTpersonDialog=false
                        that.GetSNGrantedUsers({
                            mainId:this.mainId,
                            pageIndex:this.pageIndex,
                            pageSize:this.pageSize
                        });                        
                        setTimeout(()=>{
                            this.xiaxiantipsDialog=true
                            this.tipsphone=this.currentttrow.phone
                        },1000)
                    }
                }else{
                    that.$message.error(res.data.error_msg)
                } 
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
            
            
        },
        seeDeviceDetail(count,arr){
            console.log(count,arr)
            //this.devicedialogVisible=true 
                if(count==0){
                    return 
                }else{
                    this.devicedata=[]
                    arr.forEach(item=>{
                        this.devicedata.push(item)
                    })
                    this.devicedialogVisible=true 
                }
                
        },
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        grantSelectionChange(val){
            this.grantMultiselection=val;
        },
        returnClick(){
            let queryinfo=this.$route.query
            let obj={}
            if(queryinfo.pageSize){
                obj.pageSize=queryinfo.pageSize
                obj.pageIndex=queryinfo.pageIndex
            }
            this.$router.push({
                path:'/EmPowerAsPro',
                query:obj
            })
            //this.$router.push('/EmPowerAsPro')
        },
        confirmMessage(operatetype){//确认弹窗
            let that=this;
          
            if(operatetype==='grant'){
                if(!this.grantMultiselection.length){
                    this.$message.error('请勾选成员！')
                    return 
                }
                if(parseInt(this.grantMultiselection.length)>parseInt(this.unUsedSNCount)){
                    this.$message.error('成员所在部门及以上部门的可用授权数量不足，请重新选择！')
                    return 
                }

                this.$confirm('您确定给该成员分配授权吗?', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'message-logout'
                }).then(() => {
                    MyZhugeTrackGrantSN({
                        "管理方式":'按产品'
                    })
                    //按产品分配授权时候需要请求接口，如果该部门管理员没有授权、则需要从上级部门中分配
                    this.GetProductSnInDepartment()


                    // if(that.productType==0){//分配客户端软件产品授权
                    //     mydebounce(that.GrantProductToUser,200)();
                    // }else if(that.productType==1){
                    //     mydebounce(that.GrantSAASToUser,200)();
                    // }
                }).catch(() => {  
                    
                    console.log('取消')
                });
           }else if(operatetype==='cancle'){
               this.$confirm('您确定要取消该成员的授权吗?', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'message-logout'
                }).then(() => {

                    MyZhugeTrackCancleGrantSN({
                        "管理方式":'按产品'
                    })
                    if(that.productType==0){
                        that.CancelProductSN();
                    }else if(that.productType==1){
                        that.CancelSAASProductSN();
                    }
                }).catch(() => {  
                    
                });
           }
        },
        GetProductSnInDepartment(){
            let that=this
            let userIds=[]
            this.grantMultiselection.forEach(item=>{
                userIds.push(item.userId)
            })
            let reqdata={
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                userIds:userIds,
                mainId:this.mainId
            }
            console.log(reqdata)
            GetProductSnInDepartmentApi(reqdata)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                     const {data}=res.data;
                     console.log(data)
                     this.grantConfirmTip(data)
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        grantConfirmTip(data){
            if(data.typeNum===0){
                this.grantProductToUser()
            }else if(data.typeNum===1){//成员所在部门没有足够的授权
                this.$message.error(data.showMessage)
            }else if(data.typeNum===3){//成员所在部门和上级部门没有足够的授权
                this.$message.error(data.showMessage)
            }
            else if(data.typeNum===2){//成员所在部门没有授权，将从上级部门分配
                this.$confirm(data.showMessage, '提示信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'message-logout'
                }).then(() => {
                    this.grantProductToUser()
                })
                .catch(() => {  
                });
            } 
        },
        grantProductToUser(){
            let that=this
            if(that.productType==0){//分配客户端软件产品授权
                mydebounce(that.GrantProductToUser,200)();
            }else if(that.productType==1){
                mydebounce(that.GrantSAASToUser,200)();
            }
        },
        getProductInfo(mainId){//获取产品详情信息
            let that=this;
            GetProductGrantInfoApi({
                mainId:mainId
            })
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data){
                        that.productName=data.productName,
                        that.unUsedSNCount=data.unUsedCount,
                        that.allSNCount=data.totalCount
                    }
                }else{
                    that.$message.error(res.data.error_msg)
                } 
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        GetSNGrantedUsers(params){//获取该产品授权成员列表
            params.searchCondition=this.grantOrCancelinputseatch
            let that=this;
            this.memberloading=true;
            
            GetPagedSNGrantedUsersApi(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    that.total=0;
                    const {data}=res.data;
                    that.total=data.totalItems;
                    that.tableData=[];
                    that.hasPreviousPage=data.hasPreviousPage;
                    data.list.forEach(item=>{
                        let obj={
                            userId:item.userId,
                            realName:item.realName,
                            phone:item.phone,
                            department:item.department,
                            isOnLine:item.isOnLine,
                            sn:item.sn,
                            snMachinesInfo:item.snMachinesInfo,
                            deviceCount:item.deviceCount
                        }
                        that.tableData.push(obj)
                    })
                    this.memberloading=false;
                }else{
                    that.$message.error(res.data.error_msg)
                    this.memberloading=false;
                }    
            })
            .catch(err=>{
                console.log(err)
                this.memberloading=false;
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        GrantProductToUser(){//给一个成员分配一个产品的授权
            let that=this;
            let params={
                mainId:that.mainId,
                //grantUserId:that.grantMultiselection[0].userId
            }
            let bodydata=[];
            that.grantMultiselection.forEach(item=>{
                bodydata.push(item.userId)
            })

            if(bodydata.length>that.unUsedSNCount){
                this.$message.error('所选用户数量不能大于可用授权数量！')
                return 
            }
            this.empoerBtnDisable=true

            GrantProductToMultiUserApi(params,bodydata)
            .then(res=>{
                console.log(res);
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        that.$message.success('分配授权成功')
                        that.proPowerDialog=false;
                        this.empoerBtnDisable=false
                        that.GetSNGrantedUsers({
                            mainId:this.mainId,
                            pageIndex:this.pageIndex,
                            pageSize:this.pageSize
                        });
                        that.getProductInfo(that.mainId);
                    }
                }else{
                    this.empoerBtnDisable=false
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                this.empoerBtnDisable=false
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        GrantSAASToUser(){//给成员分配SAAS产品授权
            let that=this;
            let params={
                mainId:that.mainId,
            }
            let bodydata=[];
            that.grantMultiselection.forEach(item=>{
                bodydata.push(item.userId)
            })
            this.empoerBtnDisable=true
            BatchGrantSAASToEnterpriseUserApi(params,bodydata)
            .then(res=>{
                console.log(res);
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        that.$message.success('分配授权成功')
                        that.proPowerDialog=false;
                        this.empoerBtnDisable=false
                        that.GetSNGrantedUsers({
                            mainId:this.mainId,
                            pageIndex:this.pageIndex,
                            pageSize:this.pageSize
                        });
                        that.getProductInfo(that.mainId);
                    }
                }else{
                    this.empoerBtnDisable=false
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                this.empoerBtnDisable=false
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        CancelProductSN(){//取消成员一个产品的授权
            let that=this;
            let params={
                mainId:that.mainId,
            }
            let bodydata=[];
            that.multipleSelection.forEach(item=>{
                bodydata.push(item.userId)
            })
            CancelUsersProductSNApi(params,bodydata)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        that.$message.success('取消授权成功')
                        if(that.tableData.length===1){//判断当前页只有一行
                            if(that.hasPreviousPage===true){//判断当前页有上一页
                                that.pageIndex=that.pageIndex-1;
                            }else{
                                that.pageIndex=1;
                            }
                        }else{//判断当前页有多行
                            //that.pageIndex=that.pageIndex
                            if(this.multipleSelection.length==that.tableData.length){
                                if(that.hasPreviousPage===true){
                                    that.pageIndex=that.pageIndex-1;
                                }else{
                                    that.pageIndex=1;
                                }
                            }else{
                                that.pageIndex=that.pageIndex
                            }
                        }
                        
                        that.GetSNGrantedUsers({
                            mainId:this.mainId,
                            pageIndex:that.pageIndex,
                            pageSize:this.pageSize
                        });
                        that.getProductInfo(that.mainId);
                    }
                }else{
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        CancelSAASProductSN(){
            let that=this;
            let params={
                mainId:that.mainId,
                //grantUserId:that.multipleSelection[0].userId
            }
            let bodydata=[];
            that.multipleSelection.forEach(item=>{
                bodydata.push(item.userId)
            })
            CancelUsersSAASApi(params,bodydata)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data===true){
                        that.$message.success('取消授权成功')
                        if(that.tableData.length===1){//判断当前页只有一行
                            if(that.hasPreviousPage===true){//判断当前页有上一页
                                that.pageIndex=that.pageIndex-1;
                            }else{
                                that.pageIndex=1;
                            }
                        }else{//判断当前页有多行
                            
                            if(this.multipleSelection.length==that.tableData.length){
                               
                                if(that.hasPreviousPage===true){
                                    that.pageIndex=that.pageIndex-1;
                                }else{
                                    that.pageIndex=1;
                                }
                            }else{
                                that.pageIndex=that.pageIndex
                            }
                        }
                        that.GetSNGrantedUsers({
                            mainId:this.mainId,
                            pageIndex:that.pageIndex,
                            pageSize:this.pageSize
                        });
                        that.getProductInfo(that.mainId);
                    }
                }else{
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        proBtnClick(){
            let that=this;
            that.serchinput='';
            that.proPowerDialog=true;
            that.DiaTableData=[];
            let params={
                mainId:that.mainId
            }
            that.GetSNUnGrantedUsers(params);
        },
        GetSNUnGrantedUsers(params){
            let that=this;
            GetSNUnGrantedEnterpriseUsersApi(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    that.DiaTableData=[];
                    data.forEach(item=>{
                        let obj={
                            realName:item.realName,
                            phone:item.phone,
                            department:item.department,
                            userId:item.userId,
                            useSNCount:item.useSNCount,
                            addedAt:item.addedAt?moment(item.addedAt).format("YYYY-MM-DD HH:mm:ss"):''
                        }
                        that.DiaTableData.push(obj);
                    })
                }else{
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        getUserList(params){//获取成员列表
            let that=this;
            that.DiaTableData=[];
            UserList(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    data.forEach(item=>{
                        let obj={
                            realName:item.realName,
                            phone:item.phone,
                            department:item.department
                        }
                        that.DiaTableData.push(obj);
                    })
                }else{
                    that.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        searchClick(){
            if(this.serchinput){
                this.GetSNUnGrantedUsers({
                    mainId:this.mainId,
                    searchCondition:this.serchinput
                });
            }else{
                this.GetSNUnGrantedUsers({
                    mainId:this.mainId,
                });
            }
        }
    }

}
</script>

<style lang="scss" scoped>
    #manageAsPro{
        background: #fff;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .table-status{
            span{
                margin-left: 8px;
            }
        }
        .bgcorange::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #FE833D;
            }
        .bgcred::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #fe3d3d;
            }
        .bgcgreen::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #1DCB96;
        }
        .manage-button{
            width: 70px;
            height: 26px;
            line-height: 25px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            
            font-weight: 400;
            background: #FFF1E9;
            border: 1px solid #FFCDB1;
            color: #FE833D;
            border-radius: 2px;
            margin: 0 auto;
            cursor: pointer;
        }
        .dismanage-button{
            width: 70px;
            height: 26px;
            line-height: 25px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #c0c4cc;
            font-weight: 400;
            background: #fff;
            border: 1px solid #ebeef5;
            border-radius: 2px;
            margin: 0 auto;
            cursor: pointer;
        }
        .mybreadcrumb{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0 10px 20px;
            border-bottom: 1px solid #EAEAEA;
            .return-button{
                font-size: 12px;
                color: #666666;
                font-family: MicrosoftYaHei;
                margin-right: 20px;
                width: 60px;
                height: 30px;
                background: #F6F6F6;
                border: 1px solid #E0E0E0;
                border-radius: 2px;
                line-height: 30px;
                cursor: pointer;
            }
        }
        .package-info{
            overflow: hidden;
            margin: 20px 30px;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            border-left: 4px solid #0069e0;
            background:#EDF7FF;
            .packagename{
                float: left;
                font-family: FZLTZHK--GBK1-0;
                font-size: 14px;
                color: #0069e0;
                font-weight: 600;
            }
            .restpower{
                float: right;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #666666;
                font-weight: 400;
                .reststyle{
                    color: #0069e0;
                }
            }
        }
        .operate-box{
            overflow: hidden;
            position: relative;
            margin-bottom: 15px;
            margin: 0 30px;
            .operate-right{
                display: flex;
                float: right;
                .operate-btn{
                    font-size: 14px;
                    padding: 10px ;
                }
            }
            span{
                float: left;
                position: absolute;
                bottom: 0px;
                left: 0px;
                font-family: FZLTZHK--GBK1-0;
                font-size: 14px;
                color: #333333;
                font-weight: 600;
            }

        }
        .search-wraper{
            margin-bottom:20px;
            position: relative;
            display: flex;
            align-items:center;
            .search{
                position: absolute;
                left: 270px;
                font-size: 18px;
                cursor: pointer;
                color: rgb(200,200,200);
            }

        }
        .tips-wraper{
            padding: 20px 0 10px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            .tip-text{
                margin-left: 20px;
            }
        }
        .ttdialog{
            .tttipsstyle{
                width:230px;
                margin-left:20px;
                text-align:left;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #333333;
                line-height: 22px;
            }
        }
        /deep/ .el-dialog{
            border-radius: 2px;
            width: 1000px;
            .el-dialog__header{
                background: #0069e0;
                text-align: left;
                padding: 15px 20px;
                .el-dialog__title{
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    color: #FFFFFF;
                    font-weight: 400;
                }
                .el-dialog__close{
                    color: #fff;
                }
            }
            .el-input{
                width: 300px;
                
            }
        }
        /deep/ .el-table .cellstyle{
            padding: 0;
            height: 40px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #181818;
            font-weight: 400;
        }
        //common样式
        .commonwidth1{
            display: inline-block;
            width: 50px;
        }
        .commonfz14-co99{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #999999;
            font-weight: 400;
        }
        .commonfz14-co33{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333333;
            font-weight: 400;
        }
        .common-matop{
            margin-top: 15px;
        }
        
    }
    
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/EmPowerManage/manageAsPro.vue